import React from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,} from '@material-ui/core';
import ActionMenu, {Action} from '../../../components/ui/blocks/ActionMenu';
import {Row} from '../../../components/ui/blocks/DataTable';
import {UserWithRole} from '../../../types/User/UserWithRole';
import {InvitationN} from "../../../types/User/InvitationN";
import {formatDateTime} from "../../../utils/DateTimeUtil";

const useStyles = makeStyles((theme) => ({
  even: {
    border: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  },
  odd: {
    border: 'none',
    backgroundColor: theme.palette.background.default,
  },
}));

interface PendingTeamTableProps {
  team: InvitationN[];
  onAction?: (action: Action, row: UserWithRole) => void;
}

export default function PendingTeamTable({ team, onAction }: PendingTeamTableProps) {
  const { t } = useTranslation(['company', 'global']);
  const classes = useStyles();

  const actions: Action[] = [
    { id: 'delete', label: t('global:delete') },
    { id: 'resend-invitation', label: t('company:resend-invitation') },
  ];

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('emailAddress')}</TableCell>
            <TableCell>{t('invitedAt')}</TableCell>
            <TableCell>{t('role')}</TableCell>
            {onAction && <TableCell>{t('global:actions')}</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {team.map((row, index) => (
            <TableRow key={row.id || index} hover className={index % 2 === 0 ? classes.even : classes.odd}>
              <TableCell>{row.emailAddress}</TableCell>
              <TableCell>{formatDateTime(row.invitationDate)}</TableCell>
              <TableCell>{row.role}</TableCell>
              {onAction && (
                <TableCell align="left">
                  <ActionMenu
                    actions={actions}
                    row={row as unknown as Row}
                    onAction={onAction as (action: Action, row: Row) => void}
                  />
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
